import { useCallback } from 'react'
import { useAppSelector } from 'store/hooks'
import { selectThemeMode } from 'store/theme/themeSlice'
import { resolveThemeColor, ThemeColorToken } from 'theme/config'

// Resolved literal hex for the active mode, for SVG/canvas attrs where `var()` fails.
export const useThemeColors = (): ((token: ThemeColorToken) => string) => {
  const mode = useAppSelector(selectThemeMode)
  return useCallback((token: ThemeColorToken) => resolveThemeColor(token, mode), [mode])
}
